import { AlertTriangle } from "lucide-react";
import { ConfirmDialog } from "../../../../../components/ui/confirm-dialog";

/**
 * Confirmação da baixa da iMile.
 *
 * Não usa o OperationConfirmDialog porque o `details` dele renderiza em texto
 * esmaecido, e o aviso de baixa ANTECIPADA precisa ser visível — é dinheiro
 * saindo antes do vencimento. Mesmo caminho que o EnviarOfertasDialog do entrego
 * já toma quando precisa de uma confirmação mais forte: monta sobre o
 * ConfirmDialog base, sem tocar em componente compartilhado.
 *
 * A redação padrão ("Realizar baixa" / "OPS" / "Data") é a mesma do
 * OperationConfirmDialog de propósito, para a tela não parecer de outro sistema.
 */
interface RealizarBaixaDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  ops: string;
  filterDate: string;
  dataVencimento: string;
  /** true quando hoje < data_vencimento */
  isAntecipada: boolean;
  diasAteVencimento: number;
  loading?: boolean;
}

export function RealizarBaixaDialog({
  open,
  onOpenChange,
  onConfirm,
  ops,
  filterDate,
  dataVencimento,
  isAntecipada,
  diasAteVencimento,
  loading = false,
}: RealizarBaixaDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      title={isAntecipada ? "Confirmar baixa ANTECIPADA" : "Confirmar baixa"}
      confirmText={loading ? "Processando..." : "Confirmar"}
      cancelText="Cancelar"
      confirmDisabled={loading}
    >
      <div className="space-y-3">
        <p className="font-medium text-foreground">
          Realizar baixa no banco de dados
        </p>
        <p className="text-sm text-muted-foreground">
          OPS: {ops.toUpperCase()}, Data: {filterDate}
        </p>

        {isAntecipada && (
          <div className="flex gap-3 rounded-lg border border-amber-300 bg-amber-50 p-3">
            <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
            <div className="text-sm text-amber-900">
              <p className="font-semibold">Esta baixa é antecipada.</p>
              <p className="mt-1">
                O vencimento é {dataVencimento}, daqui a{" "}
                <strong>
                  {diasAteVencimento} {diasAteVencimento === 1 ? "dia" : "dias"}
                </strong>
                . Confirme só se a antecipação foi combinada.
              </p>
            </div>
          </div>
        )}
      </div>
    </ConfirmDialog>
  );
}
